import { api } from './api'

export const apiNotification = {
    getNotiList: (page, size = 10) => api.get('web/notifications', { page, size }),
}